import { render, staticRenderFns } from "./stepButton.vue?vue&type=template&id=b839bd00&scoped=true"
import script from "./stepButton.vue?vue&type=script&lang=js"
export * from "./stepButton.vue?vue&type=script&lang=js"
import style0 from "./stepButton.vue?vue&type=style&index=0&id=b839bd00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b839bd00",
  null
  
)

export default component.exports